export const AUTH_PAGE_SLUG = "auth";
